import React from "react";
import { Link } from "react-router-dom";
import ProjectCard from "../../components/ProjectCard";
import { projectData } from "../../data";

export default function Portfolio() {
  return (
    <div className="md:py-20 py-10">
      <div className="container px-4 mx-auto">
        <div className="text-center">
          <h2 className="headline text-neutral-900 dark:text-neutral-100 mb-10">
            Portfolio
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
          {
            // max 6 projects
            projectData.slice(0, 6).map((project) => (
              <ProjectCard project={project} key={project.id} />
            ))
          }
        </div>

        <div className="text-center mt-10">
          <Link
            to="/portfolio"
            className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-2 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700"
          >
            View More Projects
            <svg
              aria-hidden="true"
              className="w-5 h-5 ml-2 -mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
}
